const BRANDS = [
	'Siemens',
	'Mitsubishi',
	'Omron',
	'ABB',
	'Fluke',
	'Furuno',
	'WIKA',
	'Yaskawa',
	'Weintek',
	'Sick',
	'Mean Well',
	'Moxa',
	'Rittal',
	'Autonics',
	'Belden',
];

const BrandStrip = () => {
	return (
		<section className='container py-8'>
			<div className='section-heading'>
				<h2>Thương hiệu phân phối</h2>
				<span className='text-xs text-gray-500'>{BRANDS.length} thương hiệu chính hãng · Đại lý uỷ quyền</span>
			</div>
			<div className='bg-white rounded-lg p-5 shadow-sm border border-gray-100'>
				<div className='grid grid-cols-3 md:grid-cols-5 gap-3'>
					{BRANDS.map((b) => (
						<div key={b} className='brand-tile'>
							{b}
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default BrandStrip;
